import React from 'react';

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
};

const contentStyle = {
  flex: 1,
};

export default function Terms() {
  return (

    <div style={containerStyle}>
      <div style={contentStyle}>
        <div className="border border-2 border-gray-300 ">
          <div className="max-w-7xl mx-auto pt-5 sm:pt-24 px-4 sm:px-6 lg:px-8 ">
            <div className="lg:text-center h-30">
              <header className="mt-16  mr-14">
                <div className="container mx-auto">
                  <h1 className="text-4xl font-bold tracking-tight sm:text-6xl text-center lg:pl-24 text-navy">
                    Terms and Conditions
                  </h1>
                </div>
              </header>

            </div>

            <div className="mt-10">
                <div className='text-center'>
              <h className="mt-2 leading-8 text-center text-4xl font-bold tracking-tight text-navy sm:text-4xl">Welcome to Jusamusha!</h>


              <div className='py-3 mt-6 text-xl leading-8 text-center lg:text-left text-navy'>
                <p className='text-center'>These terms and conditions outline the rules and regulations for the use of Jusamusha's website
                </p>
              </div>
              </div>

              <div className='py-3 mt-6 leading-8 text-center lg:text-left text-lg text-navy'>
                By accessing this website we assume you accept these terms and conditions. Do not continue to use Jusamusha!'s website if you do not agree to take all of the terms and conditions stated on this page.
                The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same. Our Terms and Conditions were created with the help of the Terms & Conditions Generator.
              </div>

              <div className='py-3 mt-6 leading-8 text-center lg:text-left text-lg text-navy'>
                <h className=" mt-2 text-2xl leading-8 font-bold tracking-tight text-navy sm:text-xl py-3"  >Cookies</h>
                <p> We employ the use of cookies. By accessing Jusamusha!, you agreed to use cookies in agreement with the Jusamusha!'s Privacy Policy.
                  Most interactive websites use cookies to let us retrieve the user’s details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.
                </p>
              </div>

              <div className='py-3 mt-6  leading-8 text-center lg:text-left text-lg text-navy'>
                <h className="mt-2 text-2xl leading-8 font-bold tracking-tight text-navy sm:text-xl py-3"> License</h>
                <p>  Unless otherwise stated, Jusamusha and/or its licensors own the intellectual property rights for all material on Jusamusha. All intellectual property rights are reserved. You may access this from Jusamusha for your own personal use subjected to restrictions set in these terms and conditions.</p>

                <p className='py-5'>You must not:</p>

                <p> 1. Republish material from Jusamusha.</p>
                <p> 2. Sell, rent or sub-license material from Jusamusha</p>
                <p>3. Reproduce, duplicate or copy material from Jusamusha</p>
                <p>4. Redistribute content from Jusamusha</p>
                <p>** This Agreement shall begin on the date hereof.</p>
                <div>
                  <p>   Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Jusamusha does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Jusamusha,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, Jusamusha shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.</p>

                  <p> Jusamusha reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.</p>
                </div>
                <div className="py-3">
                  <h className="py-8">
                    You warrant and represent that:
                  </h>

                  <p>1. You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;</p>
                  <p>2. The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;</p>
                  <p>3. The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy</p>
                  <p>4. The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.</p>
                  <p>***You hereby grant Jusamusha a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.</p>
                </div>

                <div className='py-5'>
                  <h className='py-5 font-bold text-xl  text-navy'>  Hyperlinking to our Content</h>
                  <div className='py-5'>
                    <p>The following organizations may link to our Website without prior written approval:</p>

                    <p>1.  Government agencies;</p>
                    <p>2.  Search engines;</p>
                    <p>3.  News organizations;</p>
                    <p>4.  Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses; and</p>
                    <p>5.  System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.</p>
                    <div className='py-5'>
                      <p>These organizations may link to our home page, to publications or to other Website information so long as the link:</p>
                      <p>(a) is not in any way deceptive; </p>
                      <p>(b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and </p>
                      <p>(c)fits within the context of the linking party’s site.</p>
                    </div>
                  </div>
                </div>
                <div>
                  <p> We may consider and approve other link requests from the following types of organizations:</p>
                  <p>- commonly-known consumer and/or business information sources;</p>
                  <p>- dot.com community sites;</p>
                  <p>- associations or other groups representing charities;</p>
                  <p>- online directory distributors;</p>
                  <p>- internet portals;</p>
                  <p>- accounting, law and consulting firms; and</p>
                  <p>- educational institutions and trade associations.</p>
                </div>

                <div className='py-3'>
                  <p> We will approve link requests from these organizations if we decide that:</p>
                  <p> (a) the link would not make us look unfavorably to ourselves or to our accredited businesses;</p>
                  <p> (b) the organization does not have any negative records with us;</p>
                  <p> (c) the benefit to us from the visibility of the hyperlink compensates the absence of Jusamusha; and</p>
                  <p> (d) the link is in the context of general resource information.</p>
                </div>
                <div className='py-3'>
                  <p>These organizations may link to our home page so long as the link: </p>
                  <p> (a) is not in any way deceptive; </p>
                  <p> (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and</p>
                  <p> (c) fits within the context of the linking party’s site.</p>

                  <p className='py-3'> If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to Jusamusha. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.</p>
                </div>

                <div>
                  <p>  Approved organizations may hyperlink to our Website as follows:</p>
                  <p> - By use of our corporate name; or </p>
                  <p> - By use of the uniform resource locator being linked to; or </p>
                  <p> - By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party’s site.</p>
                  <p> No use of Jusamusha's logo or other artwork will be allowed for linking absent a trademark license agreement. </p>
                </div>

                <div className='py-3'>
                  <h className='py-3 font-bold text-xl text-base text-navy'> iFrames</h>
                  <p> Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.
                  </p>
                  <h className='py-3 font-bold text-xl text-base text-navy'> Content Liability</h>
                  <p> We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.
                  </p>
                  <h className='py-3 font-bold text-xl text-base text-navy'> Reservation of Rights</h>
                  <p>We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and it’s linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.
                  </p>

                  <h className='py-3 font-bold text-xl text-base text-navy'>Removal of links from our website</h>
                  <p>If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.
                  </p>
                  <p>  We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.
                  </p>

                  <h className='py-3 font-bold  text-lg text-navy'>Disclaimer</h>
                  <p> To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:
                  </p>
                  <p> - limit or exclude our or your liability for death or personal injury;</p>
                  <p> - limit or exclude our or your liability for fraud or fraudulent misrepresentation;</p>
                  <p> - limit any of our or your liabilities in any way that is not permitted under applicable law; or</p>
                  <p> - exclude any of our or your liabilities that may not be excluded under applicable law.</p>

                  <p className='py-3'>The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: </p>
                  <p><span className='font-bold text-xl'>(a)</span> are subject to the preceding paragraph; and </p>
                  <p><span className='font-bold text-xl'>(b)</span> govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.</p>

                  <p className='py-3'>As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>

  )
}
